<template>
  <div class="section-report">
    <Wrapper title="停投统计">
      <template #header>
        <el-row>
          <el-col
            :offset="4"
            :span="20"
            style="text-align: right;"
          >
            <DatePicker @pick="pickDate" />
          </el-col>
        </el-row>
      </template>
      <template #content>
        <div class="box">
          <div class="chart">
            <div
              ref="chartblock"
              style="height: 500px"
            />
          </div>
          <div class="table">
            <el-table
              :data="table.list"
              style="width: 100%"
              :cell-class-name="setTableCellClass"
              header-row-class-name="table-header"
            >
              <el-table-column
                label="排名"
                width="100px"
              >
                <template slot-scope="scope">
                  <span
                    class="table-index"
                    :style="makeTableRankStyles(scope.$index)"
                  >
                    {{ scope.$index + 1 }}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="product_name"
                label="合作产品"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.product_name || '--' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="company"
                label="广告主公司名称"
              >
                <template slot-scope="scope">
                  <a
                    style="text-decoration: none; cursor: pointer; color: #2F9EFF"
                    @click="toDetail(scope.row.customer_id)"
                  >
                    {{ scope.row.company || '--' }}
                  </a>
                </template>
              </el-table-column>
              <el-table-column
                prop="date"
                label="停投日期"
              />
            </el-table>

            <el-pagination
              :current-page.sync="table.page"
              :page-sizes="[7]"
              layout="total, sizes, prev, pager, next"
              :total="table.total"
              style="margin-top: 5px; float: right"
              @size-change="handlePageSizeChange"
              @current-change="handleQueryPage"
            />
          </div>
        </div>
      </template>
    </Wrapper>
  </div>
</template>

<script>
import echarts from 'echarts';
import $util from '@/common/js/util';
import { baseBarOption } from '../echartConfig';
import roma from '../echartConfig/roma.json';
import Request from '@/core/QuRequest';
import rank1 from '@/assets/image/rank/rank_1.png';
import rank2 from '@/assets/image/rank/rank_2.png';
import rank3 from '@/assets/image/rank/rank_3.png';
import Wrapper from '../components/Wrapper';
import DatePicker from '../components/DatePicker';

const req = new Request();
export default {
  name: 'SectionStop',
  components: {
    Wrapper,
    DatePicker,
  },
  data() {
    return {
      // 列表序号样式
      rank: {
        rank1,
        rank2,
        rank3,
      },

      // pick date
      date: '',
      timeDuration: [],

      // chart data
      stopCharts: null,
      chartOpt: { ...baseBarOption },
      chartData: [],

      // table
      table: {
        page: 1,
        pageSize: 5,
        list: [],
        total: 0,
        loading: false,
      },
    };
  },

  created() {
    echarts.registerTheme('roma', roma);
    this._fetchStopPutData();
  },

  mounted() {
    this.stopCharts = echarts.init(this.$refs.chartblock, 'roma');
    window.addEventListener('resize', this.stopChartsResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.stopChartsResize);
  },

  methods: {
    // 选择日期
    pickDate({ duration = [] } = {}) {
      this.timeDuration = duration;
      this.date = duration[0] + ',' + duration[duration.length - 1];
      this._fetchStopPutData();
    },

    // table 序号样式
    makeTableRankStyles(i) {
      if (i < 3) {
        let res = {
          color: '#fff',
          background: '',
          width: '26px',
          height: '26px',
          marginLeft: '-4px',
        };
        const t = this.rank[`rank${i + 1}`];
        res.background = `url(${t}) no-repeat center center / 72%`;
        return res;
      }
      return {};
    },

    // 设置列样式
    setTableCellClass({ columnIndex }) {
      if (columnIndex === 2) {
        return 'table-cell-prod';
      }
    },

    // 获取数据
    async _fetchStopPutData() {
      if (!this.date) return;
      try {
        this.chartData = [];
        const params = {
          date: this.date,
          page: this.table.page,
          pageSize: this.table.pageSize,
        };
        const res = await req.send(req.Apis.sales.report.stopPut, params);
        this.chartData = this.matchSeriesData(
          'num',
          (res.data || {}).chart || {},
        );
        this.table.list = [...(res.data.list || [])];
        this.table.total = Number(res.data.total || 0);

        this.setChart();
      } catch (err) {
        this.$message.error(`获取数据失败：${err.message || '未知错误'}`);
      }
    },

    // 匹配chart数据
    matchSeriesData(type = 'num', ori = {}) {
      return this.timeDuration.map((i) => {
        return ori[i] ? ori[i][type] : null;
      });
    },

    // 配置图表
    setChart() {
      this.chartOpt.title.text = '停投分布';
      this.chartOpt.xAxis = {
        type: 'category',
        data: this.timeDuration,
      };
      this.chartOpt.yAxis.axisLabel = {
        formatter: '{value} 个',
      };
      this.chartOpt.series = [
        {
          name: '停投客户数',
          type: 'bar',
          barWidth: '50%',
          data: this.chartData,
        },
      ];
      this.chartOpt.dataZoom = [
        {
          type: 'slider',
          show: true,
          xAxisIndex: [0],
          start: 1,
          end: 100,
        },
      ];
      this.stopCharts.setOption(this.chartOpt);
    },

    // 页量改变
    handlePageSizeChange(pageSize) {
      this.table.pageSize = Number(pageSize);
      this._fetchStopPutData();
    },

    // 页码改变
    handleQueryPage(page) {
      this.table.page = Number(page);
      this._fetchStopPutData();
    },

    // 监听页面size
    stopChartsResize() {
      this.stopCharts && this.stopCharts.resize();
    },

    // 跳转广告主详情
    toDetail(id) {
      if (!id) return;
      let url = '/advertiser-manage/detail';
      url += `?id=${id}`;
      $util.openUrl(url, { newWin: true });
    },
  },
};
</script>

<style lang="less" scoped>
.section-report {
  .table {
    padding-top: 48px;
    overflow: hidden;

    /deep/ .el-table th {
      padding: 12px 0;
    }

    /deep/ .el-table td {
      padding: 12px 0;

      &.table-cell-prod {
        color: #2f9eff;
      }
    }

    /deep/ .table-header {
      background: #fafafa;
      border-radius: 4px 4px 0px 0px;

      th {
        background: transparent;
        color: #303133;
        font-size: 14px;
        font-weight: 500;
      }
    }

    .table-index {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      background: #f0f2f5;
      margin-right: 24px;
      font-size: 12px;
      font-family: HelveticaNeue-Medium;
      font-weight: 500;
      color: rgba(96, 98, 102, 1);
    }
  }
}
</style>
